import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { BaseAppGlobalPopUp } from "./BaseAppGlobalPopUp";
import { Reservation } from "../_models/Reservation";
import { PMSLocationsActions } from "../../PMS/_actions/PMSLocationsActions";

export function DeleteReservationGlobalPopUp({
    reservation = Reservation(),
}) {

    //LIBRARIES
    const { t } = useTranslation();
    const dispatch = useDispatch();

    //ACTION HANDLERS
    function handleDeleteReservation() {
        dispatch(PMSLocationsActions.deleteReservation(reservation.uid));
    }
    
    //VIEW
    return (
        <BaseAppGlobalPopUp
            title={t(
                "mod_pms_reservation_delete_question",
                { id: reservation.reservationId }
            )}
            body={t("mod_pms_reservation_delete_description")}
            onAccept={handleDeleteReservation}
        />
    );
}